import { therapyPlanningAction } from 'src/redux/actions/constant';

const {
  GET_THERAPY_PLANNING_DISCHARGE_SUCCESS_2_0,
  GET_THERAPY_PLANNING_DISCHARGE_FAILURE_2_0,
  GET_THERAPY_PLANNING_DISCHARGE_REQUEST_2_0,
  GET_THERAPY_PLANNING_DISCHARGE_RESET_2_0,
  GET_THERAPY_PLANNING_DISCHARGE_LOADING_2_0,
} = therapyPlanningAction;

const intitialstate: object = {
  response: null,
  loading: false,
  isGetDischarge: false,
};

export const getTherapyPlanningDischargeDateReducer_2_0 = (state = intitialstate, action: any) => {
  switch (action.type) {
    case GET_THERAPY_PLANNING_DISCHARGE_SUCCESS_2_0: {
      return {
        ...state,
        response: action.payload,
        loading: false,
        isGetDischarge: true,
      };
    }

    case GET_THERAPY_PLANNING_DISCHARGE_FAILURE_2_0:
      return {
        ...state,
        response: action.payload,
        loading: false,
        isGetDischarge: false,
      };
    case GET_THERAPY_PLANNING_DISCHARGE_LOADING_2_0:
      return {
        ...state,
        loading: true,
      };

    case GET_THERAPY_PLANNING_DISCHARGE_RESET_2_0:
      return intitialstate;

    default:
      return state;
  }
};
